import React from 'react';
import { useNavigate } from 'react-router-dom';
import { HEADER_CONTENT_MAP, ROUTES } from 'src/constants';
import { useIndustry } from 'src/context';
import { ReactComponent as SetupIcon } from 'src/assets/images/icons/gear-icon.svg';
import './header.css';

const Header: React.FC = () => {
  const navigate = useNavigate();
  const { industry } = useIndustry();
  const { cssStyles, logo, logoText, navLinks } = HEADER_CONTENT_MAP[industry];

  return (
    <header className={`header-container ${cssStyles['header-container']}`}>
      <div className={`header ${cssStyles['header']}`}>
        <div
          className={`logo ${cssStyles['logo']}`}
          onClick={() => navigate(ROUTES.home)}
        >
          <img src={logo.src} alt={logo.alt} />
          <span>{logoText}</span>
        </div>
        <nav className={`nav ${cssStyles['nav']}`}>
          {navLinks?.map((link, index) => <span key={index}>{link}</span>)}
        </nav>
        <SetupIcon
          className={`icon ${cssStyles['icon']}`}
          onClick={() => navigate(ROUTES.setup)}
        />
      </div>
    </header>
  );
};

export default Header;
